const state = {
  allUsersMap: {},
  currentUser: null,
  admins: [],
  adminIds: [],

  activeConversation: null,
  activeUsers: [],
  activeUsersMap: {},

  manualAutomations: [],
  automationStatus: null,

  threadMessage: null,
  preselectedMessageId: null,
};

const getters = {};

const mutations = {
  SET_USERS_MAP(state, users) {
    state.allUsersMap = users;
  },
  SET_ADMINS(state, admins) {
    state.admins = admins;
  },
  SET_ADMIN_IDS(state, adminIds) {
    state.adminIds = adminIds;
  },
  SET_CURRENT_USER(state, user) {
    state.currentUser = user;
  },
  SET_ACTIVE_CONVERSATION(state, conversation) {
    state.activeConversation = conversation;
  },
  SET_ACTIVE_USERS(state, users) {
    state.activeUsers = users;

    let map = {};
    users.forEach((user) => {
      map[user.user_id] = user;
    });
    state.activeUsersMap = map;
  },
  SET_MANUAL_AUTOMATIONS(state, automations) {
    state.manualAutomations = automations;
  },
  SET_AUTOMATION_STATUS(state, status) {
    state.automationStatus = status;
  },
  SET_THREAD_MESSAGE(state, message) {
    state.threadMessage = message;
  },
  SET_PRESELECTED_MESSAGE_ID(state, messageId) {
    state.preselectedMessageId = messageId;
  },
};

const actions = {
  setAdmins({ commit }, admins) {
    commit("SET_ADMINS", admins);
    let adminIds = [];
    admins.forEach((admin) => adminIds.push(admin.user.user_id));
    commit("SET_ADMIN_IDS", adminIds);
  },
  addUsersToMap({ commit }, users) {
    const newUsersMap = {};
    users?.forEach((user) => {
      if (!user || !user.user_id) return;
      // UserProfile doesn't have email, the usual fallback for users without name
      user.email = "User #" + user.user_id;
      user.fullname = user?.name ? user.name : "";
      if (user?.surname?.length) {
        user.fullname += " " + (user?.surname || "");
        user.fullname = user.fullname.trim();
      }

      newUsersMap[user.user_id] = user;
    });

    commit("SET_USERS_MAP", {
      ...state.allUsersMap,
      ...newUsersMap,
    });
  },
  setCurrentUser({ commit }, user) {
    commit("SET_CURRENT_USER", user);
  },
  setActiveConversation({ commit }, conversation) {
    commit("SET_ACTIVE_CONVERSATION", conversation);
  },
  setActiveUsers({ commit }, users) {
    commit("SET_ACTIVE_USERS", users);
  },
  setManualAutomations({ commit }, automations) {
    commit("SET_MANUAL_AUTOMATIONS", automations);
  },
  setAutomationStatus({ commit }, status) {
    commit("SET_AUTOMATION_STATUS", status);
  },
  setThreadMessage({ commit }, message) {
    commit("SET_THREAD_MESSAGE", message);
  },
  setPreselectedMessageId({ commit }, messageId) {
    commit("SET_PRESELECTED_MESSAGE_ID", messageId);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
